import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Power } from "lucide-react";

export function DutyToggle() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { client.get("/tm/duty").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const flip = async () => {
    setBusy(true);
    try {
      const { data } = await client.post("/tm/duty", { on: !d.on_duty });
      setD({ ...d, ...data });
      toast.success(data.on_duty ? (d.paused_by_admin ? "Duty ON — par admin ne leads pause ki hain" : "Leads ON — 15 min me pick karein") : "Leads OFF — nayi leads nahi aayengi");
    } catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  const on = d.on_duty;
  const paused = on && d.paused_by_admin;
  return (
    <button onClick={flip} disabled={busy} data-testid="tm-duty-toggle" title={on ? "Stop leads" : "Start leads"}
      className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold border rounded-full whitespace-nowrap shrink-0 transition-colors duration-200 disabled:opacity-60 ${paused ? "border-[#eab308]/60 text-[#eab308]" : on ? "border-bull/60 text-bull bg-[rgba(34,197,94,0.08)]" : "border-bear/50 text-bear"}`}>
      <span className={`w-2 h-2 rounded-full ${on ? "bg-[#22c55e] animate-pulse" : "bg-[#ef4444]"}`} />
      <Power size={13} />
      <span data-testid="tm-duty-state">{paused ? "Paused by admin" : on ? "Leads ON" : "Leads OFF"}</span>
    </button>
  );
}
